import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { SITE } from "@/lib/api";

const Section = ({ title, children }) => (
  <Reveal>
    <section className="rounded-3xl border border-[#D8E5E8] bg-white p-7 shadow-[0_10px_40px_-28px_rgba(16,51,59,0.3)] sm:p-10">
      <h2 className="font-display text-xl font-semibold text-[#1A2E33] sm:text-2xl">{title}</h2>
      <div className="mt-4 space-y-4 text-sm leading-relaxed text-[#5C7178] sm:text-base">{children}</div>
    </section>
  </Reveal>
);

export default function PrivacyPolicy() {
  return (
    <main>
      <PageHero
        eyebrow="Documento legale"
        titleLines={["Informativa Privacy", "(Reg. UE 2016/679 — GDPR)."]}
        subtitle="Come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali quando navighi sul sito o ci contatti."
      />

      <div className="mx-auto max-w-4xl space-y-6 px-5 py-12 pb-28 sm:px-8" data-testid="privacy-policy-page">
        <Section title="1. Titolare del trattamento">
          <p>
            Il titolare del trattamento è {SITE.legalName}, con sede in {SITE.address}, P.IVA / C.F.{" "}
            {SITE.piva}. Per qualsiasi questione relativa alla privacy puoi scrivere a{" "}
            <a href={`mailto:${SITE.email}`} className="text-[#1F8296] underline underline-offset-2 hover:text-[#238496]">{SITE.email}</a>{" "}
            o chiamare il numero{" "}
            <a href={`tel:${SITE.phone}`} className="text-[#1F8296] underline underline-offset-2 hover:text-[#238496]">{SITE.phoneDisplay}</a>.
          </p>
        </Section>

        <Section title="2. Dati personali raccolti">
          <p>
            <strong className="text-[#33484F]">Dati forniti volontariamente.</strong> Tramite il modulo di
            contatto raccogliamo: nome e cognome, indirizzo email, numero di telefono (facoltativo) e il
            contenuto del messaggio.
          </p>
          <p>
            <strong className="text-[#33484F]">Dati di navigazione.</strong> Solo se accetti i cookie
            analitici, raccogliamo statistiche di visita aggregate e anonime (pagine visitate e numero di
            visite), senza indirizzi IP né altri identificatori.
          </p>
          <p>
            <strong className="text-[#33484F]">Area riservata.</strong> Per gli amministratori del sito
            vengono trattate le credenziali di accesso (email e password in forma cifrata).
          </p>
        </Section>

        <Section title="3. Finalità e base giuridica">
          <p>
            I dati del modulo di contatto sono trattati esclusivamente per rispondere alle tue richieste
            di informazioni sui corsi (esecuzione di misure precontrattuali, art. 6.1.b GDPR). Le
            statistiche di navigazione si basano sul tuo consenso (art. 6.1.a GDPR), revocabile in
            qualsiasi momento dalle preferenze cookie. Le credenziali dell'area riservata sono trattate
            per legittimo interesse alla sicurezza e gestione del sito (art. 6.1.f GDPR).
          </p>
        </Section>

        <Section title="4. Modalità di trattamento e conservazione">
          <p>
            I dati sono trattati con strumenti informatici, con misure tecniche e organizzative adeguate
            a garantirne sicurezza e riservatezza. I messaggi di contatto sono conservati per il tempo
            necessario a gestire la tua richiesta e comunque non oltre 24 mesi, salvo tuo successivo
            rapporto contrattuale con la Scuola. Le statistiche di navigazione aggregate sono conservate
            per 12 mesi.
          </p>
        </Section>

        <Section title="5. Comunicazione e diffusione">
          <p>
            I tuoi dati non vengono venduti, ceduti né diffusi a terzi. Possono essere trattati, per conto
            del titolare, esclusivamente dai fornitori tecnici che gestiscono l'hosting del sito e
            l'invio delle email, nominati responsabili del trattamento ai sensi dell'art. 28 GDPR.
          </p>
        </Section>

        <Section title="6. I tuoi diritti">
          <p>
            In qualsiasi momento puoi esercitare i diritti previsti dagli artt. 15-22 GDPR: accesso ai
            tuoi dati, rettifica, cancellazione ("diritto all'oblio"), limitazione del trattamento,
            portabilità e opposizione. Puoi inoltre revocare il consenso prestato senza pregiudicare la
            liceità del trattamento precedente.
          </p>
          <p>
            Per esercitare i diritti scrivi a{" "}
            <a href={`mailto:${SITE.email}`} className="text-[#1F8296] underline underline-offset-2 hover:text-[#238496]">{SITE.email}</a>.
            Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali
            (www.garanteprivacy.it).
          </p>
        </Section>

        <Section title="7. Cookie">
          <p>
            Per informazioni dettagliate sui cookie utilizzati da questo sito e sulla gestione del
            consenso, consulta la{" "}
            <Link to="/cookie-policy" className="text-[#1F8296] underline underline-offset-2 hover:text-[#238496]">
              Cookie Policy
            </Link>
            .
          </p>
        </Section>

        <Section title="8. Modifiche alla presente informativa">
          <p>
            Il titolare può aggiornare questa informativa in qualsiasi momento. La versione vigente è
            quella pubblicata su questa pagina.
          </p>
          <p className="font-plex text-xs uppercase tracking-[0.2em] text-[#7A8F96]">
            Ultimo aggiornamento: luglio 2026
          </p>
        </Section>
      </div>
    </main>
  );
}
